export default __webpack_public_path__ + "static/media/juteyarn163.0092e3f7.jpg";